export default {
    system: {
        settings: "Settings",
        cancel: "Cancel",
        confirm: "Confirm",
        delete: "Delete",
        reset: "Reset",
        deleteConfirm: "Are you sure you want to delete?",
        success: "Operation Successful",
        close: "Close",
    },
    save: "Save",
    update: "Update",
    search: "Search",
    reset: "Reset",
    delete: "Delete",
    delete_success: "Deleted successfully",
    delete_failed: "Failed to delete",
    created_at: "Created At",
    actions: "Actions",
};
